import dashboard from "@/views/dashboard/dashboard";
export default dashboard;
